import React from 'react';
import Button from '@zg-rentals/multibrand-ui/lib/Button';

type Props = {
  goToStartNewTermPage: () => void;
};

class StartNewTermButton extends React.Component<Props> {
  render(): React.ReactNode {
    return (
      <Button type="tertiary" full onClick={this.props.goToStartNewTermPage}>
        Set up your next term
      </Button>
    );
  }
}
export default StartNewTermButton;
